import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

import api from '../../config/api'

import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from './styles'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

import { useLocation } from 'react-router';
import queryString from 'query-string';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        color: '#FFF',
        fontSize: 20,
        fontWeight: 600
    },
}));



const FormSchema = yup.object().shape({
    password: yup.string()
        .required('Senha é obrigatória')
        .min(6, 'A senha deve conter pelo menos 6 caracteres'),
    passwordConfirm: yup.string()
        .required('Confirmação de senha é obrigatória')
        .oneOf([yup.ref('password'), null], 'As senhas devem corresponder'),
});


interface IFormInputs {
    email: string,
    password: string,
    passwordConfirm: string,
    branch_id: number
}

export default function ResetPassword() {
    const location = useLocation();
    const classes = useStyles();

    const { register, handleSubmit, formState: { errors } } = useForm<IFormInputs>({
        resolver: yupResolver(FormSchema)
    });

    const { email, token } = queryString.parse(location.search);
    console.log(email, token)

    const history = useHistory()

    const handleSubmitForm = async (data: IFormInputs) => {
        try {
            await api.post('users/resetpass', {
                ...data,
                email,
                token
            })
            toast.success("Senha atualizada com sucesso! 😀")
            history.push('login')
        } catch (err) {
        if(err instanceof Error){
            if (err.message = 'User already registred')
                toast.error('Este usuário já foi registrado!')
        }
            else{
                toast.error('Ocorreu algum erro!')
            }       
        }
    };

    return (
        <Container component="main" maxWidth="xs" >
            <CssBaseline />

            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Prossiga para atualizar a sua senha
                </Typography>

                <form className={classes.form} onSubmit={handleSubmit(handleSubmitForm)} >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="password"
                                label="Nova Senha"
                                {...register('password')}
                                error={errors.password ? true : false}
                                name="password"
                                type="password"
                                autoComplete="current-password"
                            />
                            {errors.password && <ErrorMessage>{errors.password.message}</ErrorMessage>}
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Confirme a nova senha"
                                {...register('passwordConfirm')}
                                error={errors.passwordConfirm ? true : false}
                                type="password"
                                id="passwordConfirm"
                                autoComplete="current-password"
                            />
                            {errors.passwordConfirm && <ErrorMessage>{errors.passwordConfirm.message}</ErrorMessage>}
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Atualizar Senha
                    </Button>
                </form>
            </div>
        </Container>
    );
}
